import { Button } from '@ordr-as/umami-react/button';
import type { FC } from 'react';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCheckout } from '../../../../../context/CheckoutContext';
import ConfirmPaymentDialog from '../../../../../components/ConfirmPaymentDialog';
import type { PaymentMethodDto } from '../../../../../../generated-api';

interface Props {
  paymentMethod: PaymentMethodDto;
  className: string;
  onClick: (paymentMethod: PaymentMethodDto, dynamicFields?: Record<string, string>) => void;
  busy: boolean;
}

const UnintegratedPaymentButton: FC<Props> = (props) => {
  const { paymentMethod, className, onClick, busy } = props;
  const shouldDisplayDialog =
    (paymentMethod.unintegratedPaymentFields && paymentMethod.unintegratedPaymentFields.length > 0) || false;
  const { setSelectedPaymentMethod, setSidebarContent } = useCheckout();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleClick = () => {
    if (shouldDisplayDialog) {
      setSelectedPaymentMethod(paymentMethod);
      setSidebarContent('PAYMENT');
      return;
    }
    setIsDialogOpen(true);
  };

  return (
    <>
      <Button className={className} kind="primary" isDisabled={busy} onClick={handleClick}>
        {!busy && (
          <p>
            <b>
              <FormattedMessage id="paymentButton.text" />
            </b>
          </p>
        )}
        <div className="truncate-2">{paymentMethod.label}</div>
      </Button>
      {isDialogOpen && (
        <ConfirmPaymentDialog
          label={paymentMethod.label}
          onClose={() => setIsDialogOpen(false)}
          onConfirm={() => {
            setIsDialogOpen(false);
            onClick(paymentMethod);
          }}
        />
      )}
    </>
  );
};

export default UnintegratedPaymentButton;
